import TextAlignCenter20 from '@carbon/icons-react/es/text--align--center/20';
import TextAlignLeft20 from '@carbon/icons-react/es/text--align--left/20';
import TextAlignRight20 from '@carbon/icons-react/es/text--align--right/20';
import React, { FC } from 'react';
import { useDocuments } from 'components/organisms/document/document-store';
import { TranslationKey, useTranslation } from 'hooks/use-translation';
import { ToolItem } from '../../styled-components';

export enum AlignmentToolTypes {
  Left = 'left',
  Right = 'right',
  Center = 'center',
}

interface AlignmentToolProps {
  icon: React.ReactNode;
  type: string;
  editor?: any;
}
const AlignmentTool: FC<AlignmentToolProps> = ({
  icon,
  type,
  editor: _editor,
}) => {
  const [state] = useDocuments();
  const editor = _editor ?? state.editor;

  const executes = (alignment: string) => {
    editor?.execute('alignment', { value: alignment });
    editor?.editing.view.focus();
  };

  return (
    <ToolItem onClick={() => executes(type)}>
      {icon}
      {useTranslation(`toolbar.alignment_${type}` as TranslationKey)}
    </ToolItem>
  );
};

export const ChangeAlignmentLeft: FC<{ editor?: any }> = ({ editor }) => {
  return (
    <AlignmentTool
      icon={<TextAlignLeft20 />}
      type={AlignmentToolTypes.Left}
      editor={editor}
    />
  );
};

export const ChangeAlignmentRight: FC<{ editor?: any }> = ({ editor }) => {
  return (
    <AlignmentTool
      icon={<TextAlignRight20 />}
      type={AlignmentToolTypes.Right}
      editor={editor}
    />
  );
};

export const ChangeAlignmentCenter: FC<{ editor?: any }> = ({ editor }) => {
  return (
    <AlignmentTool
      icon={<TextAlignCenter20 />}
      type={AlignmentToolTypes.Center}
      editor={editor}
    />
  );
};
